<template>
  <MainLayout>
    <div class="w-100">
      <v-card class="mx-auto">
        <v-card-title>
          <v-sheet
            :elevation="4"
            class="icon--box"
          >
            <i class="fas fa-file-contract" />
          </v-sheet>

          <span class="title ml-4">Verträge und Zuständigkeiten</span>
        </v-card-title>

        <v-card-text>
          <transition
            appear
            name="fade"
          >
            <contract-and-responsibilities-overview />
          </transition>
        </v-card-text>
      </v-card>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import ContractAndResponsibilitiesOverview from "@/components/UserManagement/ContractsAndResponsibilities/Overview.vue";

export default {
  components: {
    MainLayout,
    ContractAndResponsibilitiesOverview,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.icon--box {
  top: -30px;
  background-color: #e72b37;
  border-radius: 4px;
  text-align: start !important;
  padding: 28px !important;
  margin-bottom: -24px !important;

  font-size: 20px;
  color: #fff;
}

@keyframes slideInFromLeft {
  0% {
    opacity: 0;
    transform: translateX(-20%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
